import { render } from "./UserProfile.vue?vue&type=template&id=6ef6ca5e&scoped=true&ts=true"
import script from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"

import "./UserProfile.vue?vue&type=style&index=0&id=6ef6ca5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef6ca5e"],['__file',"src/components/UserProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ef6ca5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ef6ca5e', __exports__)) {
    api.reload('6ef6ca5e', __exports__)
  }
  
  module.hot.accept("./UserProfile.vue?vue&type=template&id=6ef6ca5e&scoped=true&ts=true", () => {
    api.rerender('6ef6ca5e', render)
  })

}


export default __exports__